import {DefaultEventsMap, EventDataType, EventID, IEventManagerWithAsync, ListenerType} from '@gongxigames/framework/core/types/IEventManager';
import {injectable, inversifyContainer} from '@gongxigames/framework/core/installer';
import {CoreDI} from '@gongxigames/framework/core/configs';

/**
 * Adapter for old framework, without global State Machine
 * it emits events only if stateMachineConfig is not defined in runSlot()
 */
@injectable()
export class SlotEventAdapter<EventsMap = DefaultEventsMap> {

    public static NAME: symbol = CoreDI.SlotEventAdapter;
    private _eventManager!: IEventManagerWithAsync;
    private _canEmit?: boolean;

    public emit<K extends keyof EventsMap>(id: EventID, ...args: EventDataType<EventsMap[K]>): void {
        if (this._canEmit) {
            this.eventManager.emit(id, ...args);
        }
    }

    public on<K extends keyof EventsMap>(id: EventID, callback: ListenerType<EventsMap[K]>, owner: Object, priority?: number): void {
        if (this._canEmit) {
            this.eventManager.on(id, callback, owner, priority);
        }
    };

    public set canEmit(value: boolean) {
        if (this._canEmit === undefined) {
            this._canEmit = value;
        }
    }

    protected get eventManager(): IEventManagerWithAsync {
        this._eventManager ??= inversifyContainer.get<IEventManagerWithAsync>(CoreDI.IEventManagerWithAsync);

        return this._eventManager;
    }
}